import { Link as RouterLink } from 'react-router';
import { Typography, Stack, Card, CardActionArea, CardContent, Divider, Link } from '@mui/material';
import type { LegalDocument } from '../legal-documents';

export default function LegalIndexEn({ documents, lang }: { documents: LegalDocument[]; lang: string }) {
  return (
    <Stack spacing={3}>
      <Typography variant="h4" fontWeight={700}>
        Legal
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Please find below the legal documents governing the use of the BRITESTAGE platform. If you have any questions,
        feel free to contact us.
      </Typography>

      <Stack spacing={2}>
        {documents.map((doc) => (
          <Card key={doc.slug} variant="outlined">
            <CardActionArea component={RouterLink} to={`/legal/${doc.slug}?lang=${lang}`}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {doc.title.en}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {doc.description.en}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Stack>

      <Divider />

      <Stack spacing={0.5}>
        <Typography variant="subtitle2" color="text.secondary">
          Legal Notice (Impressum)
        </Typography>
        <Typography variant="caption" color="text.secondary">
          21Minds GmbH · Botnanger Str. 6 · D-70193 Stuttgart
        </Typography>
        <Typography variant="caption" color="text.secondary">
          <Link href="mailto:info@britestage.com" color="inherit">
            info@britestage.com
          </Link>{' '}
          · Phone: +49-(0)711-451021-0 · Fax: +49-(0)711-451021-10
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Registered office: Stuttgart · District Court Stuttgart, HRB 19494 · Managing Director: Boris Behringer · VAT
          ID: DE198448938
        </Typography>
      </Stack>
    </Stack>
  );
}
